import * as React from 'react';

import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import * as AdminPanel from '../../admin-panel';
import CollabarySupport from '../../admin-panel/collabary-support/CollabarySupport';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./influencer-agency-admin-panel.i18n.json'));

import { InfluencersAgency } from 'types';

type Props = {
  agency: InfluencersAgency
};

const MSG_KEY = 'influencer_agency_admin_panel';

const InfluencersAgencyAdminPanel = ({ agency }: Props) => (
  <React.Fragment>
    <AdminPanel.Panel>
      <AdminPanel.Block>
        <AdminPanel.BlockTitle
          title={__t(`${MSG_KEY}.title`)}
          tooltip={__t(`${MSG_KEY}.tooltip`)}
        />
        <CollabarySupport
          profile={agency}
          profileType="influencers_agency"
        />
      </AdminPanel.Block>
    </AdminPanel.Panel>
    <VerticalSpacing type="large" />
  </React.Fragment>
);

export default InfluencersAgencyAdminPanel;
